import type { MessageKey } from "./en";

/** Korean UI catalog. Every key in {@link en} must be present. */
export const ko: Record<MessageKey, string> = {
  "app.title": "Rescript — 텍스트를 편집하듯 동영상 편집",
  "common.cancel": "취소",
  "common.close": "닫기",
  "common.delete": "삭제",
  "common.download": "다운로드",
  "common.import": "가져오기",
  "common.loading": "불러오는 중",
  "common.remove": "제거",
  "common.restore": "복원",
  "common.retry": "다시 시도",
  "common.searchOrCreate": "검색 또는 만들기…",
  "common.settings": "설정",
  "common.system": "시스템",
  "common.tools": "도구",
  "settings.appearance": "모양",
  "settings.light": "라이트",
  "settings.dark": "다크",
  "settings.interfaceLanguage": "인터페이스 언어",
  "settings.privacy": "개인정보",
  "settings.helpImprove": "앱 개선에 참여",
  "settings.telemetryHelp": "익명의 기능 사용 통계와 충돌 보고서를 보냅니다.",
  "settings.support": "지원 / 피드백",
  "settings.reportIssue": "문제 신고",
  "settings.homepage": "홈페이지",
  "settings.github": "GitHub",
  "settings.followX": "X에서 팔로우",
  "model.transcriptSource": "자막 원본",
  "model.language": "언어",
  "model.transcriptLanguage": "자막 언어",
  "model.importTranscript": "자막 가져오기",
  "upload.recentProjects": "최근 프로젝트",
  "upload.removeRecent": "최근 목록에서 제거",
  "upload.dropPrefix": "동영상 또는 오디오 파일을 여기에 놓거나",
  "upload.browse": "찾아보기",
  "upload.chooseTranscriptFirst": "먼저 위 메뉴에서 자막을 선택한 다음 미디어를 놓으세요",
  "upload.willUseTranscript": "{name} 사용 예정 · MP4, WebM, MOV, MP3, WAV 등",
  "upload.mediaFormats": "MP4, WebM, MOV, MP3, WAV, M4A 등",
  "upload.gettingReady": "준비 중",
  "upload.gettingReadyHelp": "미디어 엔진을 설정하고 있습니다. 한 번만 진행됩니다.",
  "upload.unsupported": "이 브라우저에서는 편집기를 실행할 수 없습니다",
  "upload.unsupportedHelp":
    "편집에는 SharedArrayBuffer가 필요하며, 페이지가 교차 출처 격리 상태여야 합니다. HTTPS에서 최신 Chrome, Edge, Safari 또는 Firefox를 사용해 보세요.",
  "upload.unsupportedSimd": "이 기기에서는 편집기를 실행할 수 없습니다",
  "upload.unsupportedSimdHelp": "편집에는 WebAssembly SIMD가 필요하지만 이 프로세서는 지원을 보고하지 않습니다. Windows on Arm PC에서는 Rescript를 최신 버전으로 업데이트하세요. 현재 설치 프로그램에는 에뮬레이션으로 실행되지 않는 네이티브 Arm64 빌드가 포함되어 있습니다.",
  "upload.transcribeTitle": "자막 만들기",
  "upload.transcribeText": "Whisper를 로컬에서 실행하거나 SRT / VTT를 가져옵니다.",
  "upload.editTitle": "편집",
  "upload.editText": "단어를 선택하고 Delete 키를 눌러 편집하세요.",
  "upload.exportTitle": "내보내기",
  "upload.exportText": "최종 컷을 MP4 또는 M4A로 렌더링합니다.",
  "editor.chooseTranscript": "먼저 소스 메뉴에서 자막 파일을 선택하세요.",
  "editor.chooseMedia": "동영상 또는 오디오 파일을 선택하세요.",
  "editor.undo": "실행 취소 (⌘Z)",
  "editor.redo": "다시 실행 (⇧⌘Z)",
  "editor.export": "내보내기",
  "topbar.startOver": "처음부터 다시",
  "transcript.replace": "SRT, VTT 또는 JSON에서 자막 바꾸기",
  "transcript.header": "자막",
  "transcript.wordDeleted": "{count}개 단어",
  "transcript.wordsDeleted": "{count}개 단어",
  "transcript.replaceConfirm": "현재 자막을 이 파일로 바꿀까요?",
  "transcript.invalidFile": "SRT, VTT 또는 JSON 자막 파일을 선택하세요.",
  "transcript.noSpeech": "음성이 감지되지 않았습니다. 파일에 오디오가 있는지 확인하거나 자막을 가져오세요.",
  "transcript.cut": "컷",
  "transcript.follow": "재생 위치 따라가기",
  "transcript.hideDeleted": "삭제된 단어 숨기기",
  "transcript.showDeleted": "삭제된 단어 보기",
  "transcript.correct": "수정",
  "transcript.scrollWithPlayhead": "재생 위치에 맞춰 스크롤",
  "transcript.joinSplit": "클립 분할 — 클릭하면 이 클립들을 합칩니다",
  "transcript.joinClips": "클립 합치기",
  "transcript.hesitation": "머뭇거림 감지됨(자막 없음) — 필러 단어 제거로 컷",
  "transcript.textLabel": "자막 텍스트",
  "transcript.textHint": "화살표 키로 단어 사이를 이동하며 재생 위치도 옮겨집니다. Shift와 화살표 키로 선택합니다. Backspace 또는 Delete로 단어를 컷하고, Enter로 수정하며, Space로 재생/일시정지하고, 실행 취소로 컷을 되돌립니다.",
  "transcript.textHesitation": "[머뭇거림]",
  "transcript.textCut": "컷: {text}",
  "transcript.textNothingToCut": "컷할 항목이 없습니다",
  "transcript.textUndo": "실행 취소",
  "transcript.textRedo": "다시 실행",
  "tools.bulk": "자막 일괄 정리",
  "tools.removeFillers": "필러 단어 제거",
  "tools.removeFillersTitle": "동영상에서 필러 단어(\"음\", \"어\", \"...\" 등)를 컷",
  "tools.restoreFillers": "필러 단어 복원",
  "tools.restoreFillersTitle": "컷한 모든 필러 단어를 되돌리기",
  "tools.removeSilences": "무음 제거",
  "tools.removeSilencesTitle": "동영상에서 멈춤과 무음({seconds}초 이상)을 컷",
  "tools.restoreSilences": "무음 복원",
  "tools.restoreSilencesTitle": "컷한 모든 멈춤을 되돌리기",
  "timeline.removed": "{trimmed} 제거됨 — 원본 길이 {duration}",
  "timeline.back5": "5초 뒤로",
  "timeline.playPause": "재생 / 일시정지(스페이스)",
  "timeline.forward5": "5초 앞으로",
  "timeline.split": "분할",
  "timeline.splitTitle": "재생 위치에서 클립 분할(S)",
  "timeline.splitDisabled": "분할하려면 재생 위치를 유지할 구간으로 옮기세요",
  "timeline.delete": "삭제",
  "timeline.deleteTitle": "선택한 클립 삭제(Delete)",
  "timeline.deleteDisabled": "삭제할 클립을 타임라인에서 선택하세요",
  "timeline.restore": "복원",
  "timeline.restoreTitle": "선택한 컷 복원(Delete)",
  "timeline.restoreDisabled": "복원할 컷 또는 무음 구간을 타임라인에서 선택하세요",
  "timeline.zoomOut": "축소",
  "timeline.fit": "창에 맞추기",
  "timeline.zoomIn": "확대 — 단어 가장자리를 드래그해 타이밍 조정",
  "timeline.joinClips": "이 클립들 합치기(분할 제거)",
  "timeline.trimStart": "클립 시작 자르기",
  "timeline.trimEnd": "클립 끝 자르기",
  "timeline.hesitationAdjust": "… 머뭇거림 감지됨 — 가장자리를 드래그해 조정하거나 필러 단어 제거로 컷",
  "timeline.hesitationCut": "… 머뭇거림 감지됨 — 필러 단어 제거로 컷",
  "timeline.dragTiming": "{word} — 가장자리를 드래그해 타이밍 조정",
  "timeline.scrollZoom": "스크롤하여 확대 / 축소",
  "speaker.moveStart": "이 화자가 시작되는 위치를 드래그해 이동",
  "speaker.moveLabel": "화자 라벨 이동",
  "speaker.options": "화자 옵션",
  "speaker.change": "화자 변경",
  "speaker.rename": "화자 이름 변경",
  "speaker.renameAction": "이름 변경",
  "speaker.replace": "프로젝트에서 다음으로 바꾸기…",
  "speaker.removeProject": "프로젝트에서 제거",
  "speaker.newName": "새 이름",
  "speaker.find": "화자 찾기…",
  "speaker.noMatches": "일치하는 화자가 없습니다",
  "speaker.renameTo": "{current}을(를) {next}(으)로 이름 변경",
  "speaker.button": "화자",
  "speaker.search": "검색 또는 만들기…",
  "speaker.defaultName": "화자 {number}",
  "speaker.create": "\"{name}\" 만들기",
  "export.title": "내보내기",
  "export.type": "내보내기 유형",
  "export.video": "동영상",
  "export.audio": "오디오",
  "export.transcript": "자막",
  "export.subtitles": "자막 파일",
  "export.videoUnavailable": "오디오 전용 프로젝트에서는 동영상을 내보낼 수 없습니다",
  "export.noAudio": "이 파일에는 오디오 트랙이 없습니다",
  "export.noWordsFirst": "먼저 자막을 만들거나 가져오세요",
  "export.format": "형식",
  "export.resolution": "해상도",
  "export.original": "원본",
  "export.plainText": "TXT",
  "export.markdown": "Markdown",
  "export.statOriginal": "원본",
  "export.statCuts": "컷",
  "export.statEdited": "편집본",
  "export.includeTimestamps": "타임스탬프 포함",
  "export.speakerLabels": "화자 이름 포함",
  "export.shortCues": "짧은 자막 (≤5초)",
  "export.transcriptHelp": "화자 라벨이 포함된 텍스트이며 컷한 내용은 제거됩니다.",
  "export.transcriptHelpTimestamps":
    "화자 라벨이 포함된 텍스트이며 컷한 내용은 제거됩니다. 각 발화는 편집된 타임라인 시각으로 시작합니다.",
  "export.transcriptHelpPdf":
    "PDF는 표준 라틴 글꼴을 사용합니다. 완전한 유니코드(CJK 등)에는 DOCX를 권장합니다.",
  "export.subtitlesHelp":
    "SRT와 VTT는 편집된 타임라인(컷 적용)을 사용합니다. JSON은 다시 가져오기 위해 전체 단어 목록을 유지합니다.",
  "export.subtitlesHelpShortCues":
    "SRT와 VTT는 편집된 타임라인(컷 적용)을 사용하며 짧은 문장 단위 자막(≤5초)으로 나눕니다. JSON은 다시 가져오기 위해 전체 단어 목록을 유지합니다.",
  "export.encodingHelp": "ffmpeg.wasm으로 다시 인코딩 중 — 긴 파일은 시간이 걸립니다.",
  "export.reexport": "최신 편집으로 다시 내보내기",
  "export.rendering": "브라우저에서 렌더링 중…",
  "export.downloadFile": "{name} 다운로드",
  "export.saveFile": "{name} 저장…",
  "export.saving": "저장 중…",
  "export.saveDialogTitle": "내보내기 저장",
  "export.savedAs": "{name}(으)로 저장됨",
  "export.showInFinder": "Finder에서 보기",
  "export.showInExplorer": "탐색기에서 보기",
  "export.showInFolder": "폴더에서 보기",
  "export.renderingNative": "렌더링 중…",
  "export.encodingHelpNative": "ffmpeg로 다시 인코딩 중 — 긴 파일은 시간이 걸립니다.",
  "export.downloadFormat": ".{format} 다운로드",
  "export.exportFormat": "{format} 내보내기",
  "export.timeline": "타임라인",
  "export.timelineTitle": "NLE / DAW 시퀀스 내보내기 (Resolve, Premiere, Final Cut, Pro Tools, Reaper, Blender)",
  "export.nle": "형식",
  "export.frameRate": "프레임 레이트",
  "export.timelineHelp":
    "시퀀스는 원본 미디어를 파일 이름으로 참조합니다 — 가져온 뒤 NLE에서 다시 연결하세요.",
  "export.timelineHelpAaf": "Pro Tools / Logic AAF (메타데이터만).",
  "export.timelineHelpFcpx": "Final Cut Pro FCPXML.",
  "export.timelineHelpPremiere": "Adobe Premiere Pro XML (xmeml).",
  "export.timelineHelpResolve": "DaVinci Resolve XML (xmeml).",
  "export.timelineHelpReaper": "Reaper 프로젝트 (.rpp).",
  "export.timelineHelpSamplitude":
    "Samplitude EDL (.edl) — Reaper에서도 바로 열립니다.",
  "export.timelineHelpBlender":
    "Blender 동영상 편집 프로젝트 (.blend, Blender 5.2 이상) — 원본 미디어와 같은 폴더에 저장하세요.",
  "export.aafOverCap":
    "이 편집에는 클립이 {count}개입니다. AAF는 최대 {max}개까지 지원합니다. Resolve, Premiere, Final Cut, Reaper 또는 Samplitude EDL을 사용하세요.",
  "export.preparing": "준비 중…",
  "import.reading": "자막 읽는 중…",
  "import.importing": "가져오는 중…",
  "import.failed": "가져오기 실패",
  "import.readingFile": "파일 읽는 중…",
  "import.chooseFileShort": "파일 선택…",
  "import.chooseFile": "SRT, VTT 또는 JSON 자막 선택",
  "import.selected": "{name} 선택됨",
  "banner.faster": "자막 만들기와 내보내기를 더 빠르게 하고 싶나요?",
  "banner.getDesktop": "Rescript 데스크톱 앱 받기",
  "banner.downloadFor": "{platform}용 다운로드",
  "banner.dismiss": "닫기",
  "social.githubRepo": "GitHub 저장소",
  "social.discordServer": "Discord 서버",
  "social.xProfile": "X 프로필",
  "globalError.title": "Rescript — 문제가 발생했습니다",
  "globalError.heading": "문제가 발생했습니다",
  "globalError.body":
    "편집기에서 예상치 못한 오류가 발생했습니다. 저장된 프로젝트는 이 기기에 남아 있으니, 다시 불러오면 복구될 것입니다.",
  "progress.loadingMedia": "미디어 불러오는 중…",
  "progress.loadingMediaEngine": "미디어 엔진 불러오는 중…",
  "progress.extractingAudio": "오디오 추출 중…",
  "progress.preparingMedia": "미디어 준비 중…",
  "progress.loadingSpeechModel": "음성 모델 불러오는 중…",
  "progress.loadingSpeechCache": "캐시에서 음성 모델 불러오는 중…",
  "progress.downloadingSpeech": "음성 모델 다운로드 중…",
  "progress.gpuFallback": "GPU가 중단됨 — CPU로 계속합니다…",
  "progress.detectingSpeech": "음성 감지 중…",
  "progress.transcribing": "자막 만드는 중…",
  "progress.loadingAlignCache": "캐시에서 정렬 모델 불러오는 중…",
  "progress.downloadingAlign": "정렬 모델 다운로드 중…",
  "progress.aligning": "단어 정렬 중…",
  "progress.speakers": "화자 식별 중…",
  "error.selectModel": "자막을 만들 음성 모델을 선택하세요.",
  "error.workerCrashed": "자막 생성 워커가 충돌했습니다.",
  "error.mediaEngineNetwork": "미디어 엔진을 불러오지 못했습니다 — 연결이 끊겼습니다. 인터넷을 확인한 뒤 다시 시도하세요.",
  "error.mediaEngineStalled": "미디어 엔진이 응답하지 않아 다시 시작했습니다. 다른 앱과 탭을 닫아 메모리를 확보한 뒤 다시 시도하세요.",
  "error.mediaEngineNotReady": "미디어 엔진이 아직 준비되지 않았습니다 — 페이지를 새로 고친 뒤 다시 시도하세요.",
  "error.simdUnsupported": "이 프로세서는 미디어 엔진에 필요한 WebAssembly SIMD를 지원하지 않습니다. Windows on Arm PC에서는 Rescript를 최신 버전으로 업데이트하세요. 현재 설치 프로그램에는 에뮬레이션으로 실행되지 않는 네이티브 Arm64 빌드가 포함되어 있습니다.",
  "error.processFile": "이 파일을 처리하지 못했습니다.",
  "error.extractAudio": "이 파일에서 오디오를 추출할 수 없습니다.",
  "error.nothingToExport": "모든 내용이 삭제되었습니다 — 내보낼 항목이 없습니다.",
  "error.videoExport": "동영상을 렌더링하는 중 내보내기에 실패했습니다.",
  "error.audioExport": "오디오를 렌더링하는 중 내보내기에 실패했습니다.",
  "error.exportSave": "내보낸 파일을 저장하지 못했습니다.",
  "error.diskFull": "디스크 공간이 부족해 완료할 수 없습니다. 공간을 확보한 후 다시 시도하세요.",
  "error.export": "내보내기에 실패했습니다.",
  "error.timelineExport": "타임라인 내보내기에 실패했습니다.",
  "error.timelineEmpty": "타임라인에 넣을 내용이 없습니다.",
  "error.aafTemplate": "AAF 내보내기 템플릿을 불러올 수 없습니다.",
  "error.emptyTranscript": "해당 자막 파일이 비어 있습니다.",
  "error.noTimedWords": "해당 자막에서 시간 정보가 있는 단어를 찾지 못했습니다.",
  "error.parseJson": "해당 JSON 자막을 파싱할 수 없습니다.",
  "error.jsonShape": 'JSON은 단어 배열이거나 { "words": [...] }여야 합니다.',
  "error.noWords": "내보낼 단어가 없습니다.",
  "error.projectMissing": "해당 프로젝트는 더 이상 저장되어 있지 않습니다.",
  "error.openProject": "해당 프로젝트를 열 수 없습니다.",
  "error.removeProject": "해당 프로젝트를 제거할 수 없습니다.",
  "error.readTranscript": "해당 자막을 읽을 수 없습니다.",
  "error.clearRecent": "최근 프로젝트를 지울 수 없습니다.",
  "error.modelDownload":
    "음성 모델 다운로드를 완료하지 못했습니다 — 연결이 끊겼습니다. 인터넷을 확인한 뒤 다시 시도하세요. 완료된 부분은 유지됩니다.",
  "error.gpuReset": "GPU가 재설정되어 자막 생성이 중단되었습니다(화면 잠금 후 자주 발생). 다시 시도하세요.",
  "confirm.clearRecent": "최근 프로젝트를 모두 제거할까요? 저장된 편집 내용도 삭제됩니다.",
};
